import {
  ArticleAnalyticsEntity,
  DivisionEntity,
  DivisionUserEntity,
  EventEntity,
  EventParticipantEntity,
  GameEntity,
  MarkdownTextDto,
  UserEntity,
  UserEntityRoleEnum,
} from "@citychallenge/api-public";
import { computed } from "mobx";
import { Preference } from "../storage";

export class UserModel implements UserEntity {
  constructor(
    data: UserEntity,
    private nicknamePref: Preference<string | undefined>
  ) {
    Object.assign(this, data);
  }

  public id!: string;
  public name!: string;
  public role!: UserEntityRoleEnum;
  public timezone!: string;
  public locale!: string;

  public nickname?: string | undefined;
  public image?: string | undefined;
  public phone?: string | undefined;
  public bio?: MarkdownTextDto | undefined;

  public created?: string | undefined;
  public updated?: string | undefined;
  public email?: string | undefined;
  public superAdmin?: boolean | undefined;
  public showSupportWidget?: boolean | undefined;
  public appleUserId?: string | undefined;
  public divisions?: DivisionUserEntity[] | undefined;
  public articleAnalytics?: ArticleAnalyticsEntity[] | undefined;
  public events?: EventEntity[] | undefined;
  public contactForDivisions?: DivisionEntity[] | undefined;
  public creatorOfCityGame?: GameEntity[] | undefined;
  public countedEnergyPoints?: number | undefined;
  public participations?: EventParticipantEntity[] | undefined;
  public nextAnalyticsMail?: string | undefined;

  public anonymous?: boolean | undefined;

  @computed
  public get displayName() {
    return this.nicknamePref.value || this.nickname || this.name;
  }
}
